type SaleSellerReference = {
    sellerCompanyId: string;
};

/**
 * Whether the viewer is on the selling side of a sale.
 *
 * The scope is the viewer's own companies, their own plus every sibling in the same group, and it
 * comes from the session (`useAuthUtils().companyScopeIds`), never from the sale: the sale only
 * says which company sells it, which is true for whoever reads it and safe to cache.
 *
 * Never compare `sellerCompanyId` with a single company id at a call site: that is the exact-company
 * check this replaces, and it does not recognise a sibling company in the same group.
 */
export const isSellerOfSale = (sale: SaleSellerReference, companyScopeIds: readonly string[]): boolean =>
    companyScopeIds.includes(sale.sellerCompanyId);
